import { useEffect, useState } from "react";
import { Box, Image, useMediaQuery } from "@chakra-ui/react";
import "intro.js/introjs.css";
import DeviceSelectionGif from "components/Icons/IntroSepsGif/devices_selection.gif";
import AccountSettingsGif from "components/Icons/IntroSepsGif/account_and_settings.gif";
import LanguagesGif from "components/Icons/IntroSepsGif/languages.gif";
import MobileMenuGif from "components/Icons/IntroSepsGif/mobile_menu.gif";
import { useTranslation } from "TranslationContext";
import MobileVideoGuideIcon from "components/Icons/MoobileVideoGuide.svg"
import { URLS } from "configs/brandConfig";

const GiftPage = () => {

    const [stepsEnabled, setStepsEnabled] = useState(false);
    const [steps, setSteps] = useState([]);
    const [show, setShow] = useState(false);
    const [isSmallScreen] = useMediaQuery("(min-width: 320px) and (max-width: 768px)");
    const { translate } = useTranslation();

    const updateSteps = () => {
        
        if (isSmallScreen) {
            setSteps([
                { intro: `<img src=${DeviceSelectionGif} alt="Device Selection" />` },
                { intro: `<img src=${AccountSettingsGif} alt="Account and Settings" />` },
                { intro: `<img src=${LanguagesGif} alt="Languages" />` },
                { intro: `<img src=${MobileMenuGif} alt="Mobile Menu" />` },
            ]);
        }
        else {
            setSteps([
                { element: ".deviceSelect", intro: translate["betweenregistered"] },
                { element: ".accessQuickbar", intro: translate["unreadcounts"] },
                { element: ".user", intro: translate["panelcontrols"]},
                { element: ".selectLanguage", intro: translate["preferredlanguage"] },
                { element: ".easy-access-menu", intro: translate["unreadcounts"] },
            ]);
        }
    };

    useEffect(() => {
        if (show) {
            updateSteps();
        }
    }, [show]);

    const onExit = () => {
        setStepsEnabled(false);
    };

    const createTourSteps = () => {
        setShow(true)
        setStepsEnabled(prevState => !prevState);

        setTimeout(() => {
            const tooltipLayer = document.querySelector(".introjs-tooltipReferenceLayer");

            if (tooltipLayer) {
                const helperNumberLayer = document.createElement("span");
                helperNumberLayer.classList.add("introjs-helperNumberLayer");
                helperNumberLayer.textContent = 1;
                tooltipLayer.appendChild(helperNumberLayer);
            }
        }, 100);
    };

    const onSkip = () => {
        setStepsEnabled(false);
    };

    const updateHelperLayer = (nextStepIndex) => {
        const tooltipLayer = document.querySelector(".introjs-tooltipReferenceLayer");

        if (tooltipLayer) {
            const existingHelperNumberLayer = tooltipLayer.querySelector(".introjs-helperNumberLayer");
            if (existingHelperNumberLayer && existingHelperNumberLayer.textContent === "6") {
                existingHelperNumberLayer.remove();
            }

            const helperNumberLayer = document.createElement("span");
            helperNumberLayer.classList.add("introjs-helperNumberLayer");
            helperNumberLayer.textContent = nextStepIndex + 1;
            tooltipLayer.appendChild(helperNumberLayer);
        }
    };

    const options = {
        showBullets: true,
        exitOnOverlayClick: true,
        exitOnEsc: true,
        nextLabel: "Next →",
        prevLabel: "← Back",
        skipLabel: 'Skip',
        hidePrev: true,
        doneLabel: "Done",
        overlayOpacity: 0.5,
        overlayColor: "#000",
        showStepNumbers: true,
        keyboardNavigation: true,
        scrollToElement: true,
        helperElementPadding: 10,
        showButtons: true,
        showSkipButton: true,
    };

    useEffect(() => {
        const interval = setInterval(() => {
            const tooltip = document.querySelector('.introjs-tooltip');
            if (tooltip) {
                clearInterval(interval);

                const tooltipButtonsContainer = document.querySelector(".introjs-tooltipbuttons");
                const existingSkipButton = tooltipButtonsContainer?.querySelector('.introjs-skipbutton');

                if (!existingSkipButton) {
                    const skipButton = document.createElement('a');
                    skipButton.setAttribute('role', 'button');
                    skipButton.setAttribute('tabindex', '0');
                    skipButton.classList.add('introjs-button', 'introjs-skipbutton');
                    skipButton.textContent = 'Skip';
                    skipButton.addEventListener('click', onSkip);
                    tooltipButtonsContainer.insertBefore(skipButton, tooltipButtonsContainer.firstChild);
                }
                tooltip.appendChild(tooltipButtonsContainer);
            }
        }, 100);
        setTimeout(() => clearInterval(interval), 10000);
    }, [stepsEnabled]);

    return (
        <>
            <Box
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
                w={{ base: "full", md: "50px" }}
                p={0}
                minW={"10px"}
                h={"50px"}
                borderRadius={"0px"}
                _hover={{ bg: "#00000020" }}
                onClick={createTourSteps}
            >
                <Image src={MobileVideoGuideIcon} cursor={"pointer"}
                    onClick={() => window.open(`${URLS.VIDEO_GUIDE}`, "_blank")}
                />
                {/* <GiftIcon /> */}
            </Box>
        </>
    );
};

export default GiftPage;